import React, { FC } from "react";
import "./ComingSoon.css";

interface ComingSoonProps {}

const ComingSoon: FC<ComingSoonProps> = () => (
  <div className="flex items-center justify-center text-white">
    <div className="text-center">
      <h1 className="text-5xl font-bold mb-4">Coming Soon</h1>
    </div>
  </div>
);

export default ComingSoon;
